



















































































































































import _ from 'lodash'
import RJSON from 'relaxed-json'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { User } from '@spa/store/modules/user/types'

import SpaCharacter from '@/components/organisms/Character.vue'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'

import { log } from '@spa/log'

@Component({
  components: {
    SpaCharacter,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class Index extends Mixins<PluginMixin>(PluginMixin) {
  Status = Status
  status: Status = Status.Pending
  showModal: boolean = false
  modalMessage: string = ''

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get carats(): any {
    if (_.isEmpty(this.user.aux_text_10)) {
      log.error('user has no aux_text_10')

      return
    }

    return RJSON.parse(this.user.aux_text_10)
  }

  get initialCarats(): any {
    return _.get(this.carats, 'initial-carats')
  }

  get firstMemberInfoStatus(): boolean {
    return this.$store.getters['user/getFirstMemberInfoStatus']
  }

  get registerMemberStatus(): boolean {
    return this.$store.getters['user/getRegisterMember']
  }

  get fillMemberInfoStatus(): boolean {
    return this.$store.getters['user/getFillMemberInfo']
  }

  get isfillMemberInfoInState(): boolean {
    return this.$store.getters['user/isFillMemberInfo']
  }

  get firstLikeItemStatus(): boolean {
    return this.$store.getters['user/getFirstLikeItem']
  }

  get firstSharePageStatus(): boolean {
    return this.$store.getters['user/getFirstSharePage']
  }

  get FirstPurchaseStatus(): boolean {
    return this.$store.getters['user/getFirstPurchase']
  }

  get firstShareItemStatus(): boolean {
    return this.$store.getters['user/getFirstShareItem']
  }

  get firstIntroduceFriendStatus(): boolean {
    return this.$store.getters['user/getFirstIntroduceFriend']
  }

  get firstJoinEventStatus(): boolean {
    return this.$store.getters['user/getFirstJoinEvent']
  }

  get initialCaratsCompletionStatus(): boolean {
    return this.$store.getters['user/getInitialCaratsCompletion']
  }

  get errorOnLoad() {
    return _.get(this.$store.state.user, 'error.get')
  }

  get errorOnUpDate() {
    return _.get(this.$store.state.user, 'error.update')
  }

  async created() {
    this.status = Status.Loading

    try {
      await this.initUser()
      this.status = Status.Completed
    } catch (e) {
      log.error(e)
      this.status = Status.Failed
    }
  }

  async initUser(): Promise<void> {
    await this.$store.dispatch('user/get', { force: true })
    if (!this.user || this.errorOnLoad) {
      this.modalMessage = 'お客様情報が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true
      this.status = Status.Failed

      throw new Error('failed to get user.')
    }
  }

  getStyleStatus(done: boolean): string {
    return done ? 'done' : 'yet'
  }

  getTextStatus(done: boolean): string {
    return done ? '済' : '未'
  }

}
